// 资产图表组件国际化配置 - 繁体中文
export default {
  // 圖表標題
  balanceChange: "總資產餘額變化(近六個月)",
  transactionBoard: "交易看板",
  unit: "單位:USDT",

  // 標籤頁
  tabs: {
    balanceTrend: "餘額趨勢",
    transactionOverview: "交易看板",
  },

  // 提示信息
  tooltips: {
    addToBoard: "可在畫布中選擇地址後右鍵加入交易看板",
    calculating: "總資產餘額變化數據計算中，請稍後查看",
  },

  // 交易統計
  transaction: {
    earliestInflow: "最早轉入(USDT)",
    earliestOutflow: "最早轉出(USDT)",
    transactionCount: "交易次數(次)",
    transactionAmount: "交易數量",
    counterParty: "交易對手",
  },

  // 通用
  detail: "詳情 >",
  noData: "暫無數據",
  loadingText: "拼命加載中",

  // 錯誤提示
  errors: {
    loadChartFailed: "加載圖表數據失敗,請稍後重試",
    loadTransactionFailed: "加載交易數據失敗,請稍後重試",
  },
};
